import React from 'react';

const EthicsShow = ({ 
  isAnimal, 
  isAnimalKilled, 
  isVegan, 
  isVegetarian, 
  ethicsUnknownConfirmed,
  size = 'medium', // 'small', 'medium', 'large'
  showLabels = false,
  className = ''
}) => {
  // Determine which ethics icons to show based on the data
  const getEthicsIcons = () => {
    const icons = [];

    // If ethics are unknown/uncertain, show that
    if (ethicsUnknownConfirmed) {
      icons.push({
        src: '/assets/icons/ethics_unknown.png',
        alt: 'Ethics unknown',
        label: 'Ethics unknown',
        tooltip: 'Ethics information is uncertain'
      });
      return icons;
    }

    // Vegan takes precedence over vegetarian
    if (isVegan) {
      icons.push({
        src: '/assets/icons/is_vegan_true.png',
        alt: 'Vegan',
        label: 'Vegansk',
        tooltip: 'Detta recept är veganskt'
      });
      return icons; // Vegan implies vegetarian, so we don't need to show both
    }

    // Vegetarian (but not vegan)
    if (isVegetarian && !isVegan) {
      icons.push({
        src: '/assets/icons/is_vegetarian_true.png',
        alt: 'Vegetarian',
        label: 'Vegetarisk',
        tooltip: 'This dish is vegetarian'
      });
      return icons; // Vegetarian takes precedence over animal products
    }

    // Animal killed takes precedence over animal products
    if (isAnimalKilled) {
      icons.push({
        src: '/assets/icons/is_animal_killed_true.png',
        alt: 'Animal killed',
        label: 'Animalisk',
        tooltip: 'Detta recept innehåller produkter från djur som dödas'
      });
      return icons; // Animal killed implies animal products, so we don't need to show both
    }

    // Animal products (but not killed)
    if (isAnimal && !isAnimalKilled) {
      icons.push({
        src: '/assets/icons/is_animal_true.png',
        alt: 'Contains animal products',
        label: 'Animalisk',
        tooltip: 'Detta recept innehåller djurprodukter'
      });
    }

    // If no specific ethics are set, show neutral/unknown
    if (icons.length === 0) {
      icons.push({
        src: '/assets/icons/ethics_unknown.png',
        alt: 'Ethics unknown',
        label: 'Okänd',
        tooltip: 'Ingen information om etik'
      });
    }

    return icons;
  };

  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'w-4 h-4';
      case 'large':
        return 'w-8 h-8';
      case 'medium':
      default:
        return 'w-6 h-6';
    }
  };

  const getLabelSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'text-xs';
      case 'large':
        return 'text-sm';
      case 'medium':
      default:
        return 'text-xs';
    }
  };

  const ethicsIcons = getEthicsIcons();

  if (ethicsIcons.length === 0) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {ethicsIcons.map((icon, index) => (
        <div key={index} className="flex items-center gap-1" title={icon.tooltip}>
          <img
            src={icon.src}
            alt={icon.alt}
            className={`${getSizeClasses()} object-contain`}
            onError={(e) => {
              // Fallback to a generic icon if the specific one doesn't exist
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <div 
            className={`${getSizeClasses()} bg-gray-200 rounded flex items-center justify-center hidden`}
            style={{ display: 'none' }}
          >
            <img 
              src="/assets/icons/Innehall.png" 
              alt="Unknown" 
              className="w-3 h-3"
            />
          </div>
          {showLabels && (
            <span className={`font-medium text-gray-700 ${getLabelSizeClasses()}`}>
              {icon.label}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default EthicsShow;
